<ion-card routerLinkActive="router-link-active" class="product-tile__card">
  <div class="product-tile__content-container" (click)="addToCart()">
    <ion-card-header 
      class="card-header-layout"
      [ngClass]="{ 'product-tile__header': showProviderName }"
    >
      <img
        [src]="
          product.image
            ? product.image.filePath
            : '../../../assets/icons/service-plug.svg'
        "
        class="product-tile__image"
        [ngClass]="{ 'product-tile__image--border': !product.image }"
      />
      <div [ngClass]="{ 'product-tile__header-text': showProviderName }">
        <ion-card-subtitle
          *ngIf="showProviderName"
          class="product-tile__company-name"
        >
          {{ product.companyProvider.name }}
        </ion-card-subtitle>
        <ion-card-title class="product-tile__name">{{
          product.name
        }}</ion-card-title>
        <p *ngIf="product?.description" class="product-tile__description">
          {{ product.description }}
        </p>
      </div>
    </ion-card-header>
    <ion-card-content>
      <div class="product-tile__price-and-buy">
        <p class="product-tile__price">
          {{ product.price | currency: " " }} {{ "PLN" | translate }}
        </p>
        <ion-buttons>
          <ion-button
            *ngIf="canEdit && showEditButton"
            class="rounded edit"
            (click)="onEditProductClick(); $event.stopPropagation()"
          >
            <ion-icon class="outline" name="create-outline"></ion-icon>
          </ion-button>
          <ion-button class="rounded add-to-basket">
            <ion-icon
              class="outline"
              src="../assets/icons/basket.svg"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
    </ion-card-content>
  </div>
</ion-card>
